module.exports = __webpack_public_path__ + "img/salt.23f4366.png";